import React from 'react'
import { useLocalAudioOutput } from 'amazon-chime-sdk-component-library-react'
import Fab from '@mui/material/Fab'
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined'
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined'

import ControlBarItem from './ControlBarItem'

type AudioOutputControlProps = { }

export default function AudioOutputControl(props: AudioOutputControlProps) {
  const { isAudioOn, toggleAudio } = useLocalAudioOutput()

  return (
    <ControlBarItem>
      <Fab color="primary" onClick={toggleAudio} size="small">
        {isAudioOn ? <VolumeUpOutlinedIcon /> : <VolumeOffOutlinedIcon />}
      </Fab>
    </ControlBarItem>
  )
}